import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-160d95d8")

_pushScopeId("data-v-160d95d8")
const _hoisted_1 = { class: "row" }
const _hoisted_2 = { class: "col-lg-12" }
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "card-header" }
const _hoisted_5 = { class: "form-group d-flex flex-row justify-content-between" }
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "table-responsive" }
const _hoisted_8 = { class: "table table-responsive-sm table-bordered table-striped table-sm" }
const _hoisted_9 = { class: "center" }
const _hoisted_10 = /*#__PURE__*/_createVNode("th", null, "서브몰ID", -1)
const _hoisted_11 = /*#__PURE__*/_createVNode("th", null, "파트너스명", -1)
const _hoisted_12 = /*#__PURE__*/_createVNode("th", null, "결제금액", -1)
const _hoisted_13 = /*#__PURE__*/_createVNode("th", null, "취소금액", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("th", null, "예약매출", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("th", null, "위약금매출", -1)
const _hoisted_16 = /*#__PURE__*/_createVNode("th", null, [
  /*#__PURE__*/_createTextVNode("매출액"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode("(결제-취소)"),
  /*#__PURE__*/_createVNode("br"),
  /*#__PURE__*/_createTextVNode("(예약+위약금)")
], -1)
const _hoisted_17 = /*#__PURE__*/_createVNode("th", null, "수수료", -1)
const _hoisted_18 = /*#__PURE__*/_createVNode("th", null, "정산금액", -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("th", null, "요청상태", -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("th", null, "지급일", -1)
const _hoisted_21 = /*#__PURE__*/_createVNode("th", null, "지급요청일", -1)
const _hoisted_22 = /*#__PURE__*/_createTextVNode(" 전체선택")
const _hoisted_23 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_24 = /*#__PURE__*/_createVNode("th", null, "메모", -1)
const _hoisted_25 = { class: "right" }
const _hoisted_26 = { class: "right" }
const _hoisted_27 = { class: "right" }
const _hoisted_28 = { class: "right" }
const _hoisted_29 = { class: "right" }
const _hoisted_30 = { class: "right" }
const _hoisted_31 = { class: "right" }
const _hoisted_32 = { class: "center" }
const _hoisted_33 = { key: 0 }
const _hoisted_34 = { key: 1 }
const _hoisted_35 = { class: "modal-wrapper" }
const _hoisted_36 = /*#__PURE__*/_createVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createVNode("h3", null, " 지급일 설정 ")
], -1)
const _hoisted_37 = { class: "modal-content" }
const _hoisted_38 = { class: "modal-wrapper" }
const _hoisted_39 = /*#__PURE__*/_createVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createVNode("h3", null, " 메모추가 ")
], -1)
const _hoisted_40 = { class: "modal-content" }
_popScopeId()

import axios from 'axios';
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { ApiService } from '@/services/backend-api/api.services';
import { useStore } from 'vuex';
import { key } from '@/store';
import {
  XlsxRead,
  XlsxJson,
  XlsxWorkbook,
  XlsxSheet,
  XlsxDownload,
} from 'vue3-xlsx';
import swal from '@/helper/swal.helper';
import commerceUtil from '@/helper/commerceUtil';
import dateTimeHelper from '@/helper/datetime.helper';


export default _defineComponent({
  expose: [],
  setup(__props) {

const router = useRouter();
const route = useRoute();
const store = useStore(key);
const apiService = new ApiService();
const { date } = route.query;
const scheduleList = ref([]);
const summaryData = ref({
  sales_price: 0,
  provision_price: 0,
  provisioned_price: 0,
  fishing_date: '',
});
const provisionDate = ref('');
const isAllCheck = ref(false);
const isShowModal = ref(false);
const isShowMemo = ref(false);
const memo = ref('');
const selectedPartnersId = ref('');
const sheet = ref([]);
const sheets = ref([]);
const sheetName = ref('청약신청자.xlsx');
const downloadBtn = ref(null);
onMounted(async () => {
  await getSchedule();
});
const getSchedule = async () => {
  store.commit('loading/showLoading', '데이터를 불러오는 중입니다.');
  const responseSummary = await apiService.get(
    `/v2/booking/provision/day/${date}/summary`,
  );
  summaryData.value = responseSummary.data.item;
  const response = await apiService.get(`/v2/booking/provision/day/${date}`, {
    page: 0,
    size: 100,
  });
  scheduleList.value = response.data.items;
  sheetName.value = `${date} 정산 내역.xlsx`;
  store.commit('loading/hideLoading');
  if (!response.status) {
    swal.alert(response.message);
  }
};
const viewDetail = (dataId: string) => {
  router.push(`/partners/booking-schedule/${dataId}?date=${date}`);
};
const checkAll = () => {
  scheduleList.value.forEach((schedule: any) => {
    if (schedule.provision_status !== 'NOT_APPLICABLE') {
      schedule.isCheck = !isAllCheck.value;
    }
  });
  sheet.value = [];
  scheduleList.value.forEach(schedule => {
    if (schedule.isCheck) {
      sheet.value.push({
        서브몰ID: schedule.toss_sub_mall_id,
        금액: schedule.provision_price,
        지급일: schedule.provision_date?.split('.').join('-'),
      });
    }
  });
  sheets.value = [
    {
      name: '정산내역',
      data: sheet.value,
    },
  ];
};
const checkSchedule = (schedule: any) => {
  schedule.isCheck = !schedule.isCheck;
  sheet.value = [];
  scheduleList.value.forEach(schedule => {
    if (schedule.isCheck) {
      sheet.value.push({
        서브몰ID: schedule.toss_sub_mall_id,
        금액: schedule.provision_price,
        지급일: schedule.provision_date?.split('.').join('-'),
      });
    }
  });
  sheets.value = [
    {
      name: '정산내역',
      data: sheet.value,
    },
  ];
};

// const download = async () => {
//   let checkCount = 0;
//   scheduleList.value.forEach((schedule) => {
//     if (schedule.isCheck) {
//       checkCount++;
//     }
//   });
//   if (checkCount === 0) {
//     swal.alert('선택된 내역이 없습니다.');
//     return false;
//   }
//   swal.dowloadXlsx(downloadCsv, '정산 업로드 파일을 다운로드합니다.');
// };
// const downloadCsv = () => {
//   const fileName = `${date} 정산 내역.csv`;
//   let csv = [];
//   csv.push(['서브몰ID', '금액', '지급일'].join(','));
//   scheduleList.value.forEach((schedule) => {
//     const row = [];
//     if (schedule.isCheck) {
//       row.push(
//         schedule.toss_sub_mall_id,
//         schedule.provision_price,
//         schedule.provision_date?.split('.').join('-'),
//       );
//       csv.push(row.join(','));
//     }
//   });
//   const BOM = '\uFEFF';
//   csv = BOM + csv.join('\n');
//   const csvFile = new Blob([csv], { type: 'text/csv' });
//
//   const downloadLink = document.createElement('a');
//   downloadLink.download = fileName;
//   downloadLink.href = window.URL.createObjectURL(csvFile);
//   downloadLink.style.display = 'none';
//
//   document.body.appendChild(downloadLink);
//   downloadLink.click();
// };
const download = () => {
  let checkCount = 0;
  scheduleList.value.forEach(schedule => {
    if (schedule.isCheck) {
      checkCount++;
    }
  });
  if (checkCount === 0) {
    swal.alert('선택된 내역이 없습니다.');
    return false;
  }
  swal.dowloadXlsx(downloadXlsx, '정산 업로드 파일을 다운로드 합니다.');
};
const downloadXlsx = () => {
  downloadBtn.value.click();
};
const showProvision = () => {
  isShowModal.value = true;
};
const closeProvision = () => {
  isShowModal.value = false;
};
const provision = async () => {
  if (provisionDate.value === '') {
    swal.alert('지급요청일이 지정되지 않았습니다.');
    return false;
  }
  const dataIds = [];
  scheduleList.value.forEach(schedule => {
    if (schedule.isCheck) {
      dataIds.push(schedule.partners_data_id);
    }
  });
  closeProvision();
  const response = await apiService.post('/v2/booking/provision', {
    fishing_date: date,
    provision_date: provisionDate.value,
    partners_data_ids: dataIds,
  });
  getSchedule();
};
const cancelProvision = async () => {
  let checkCount = 0;
  scheduleList.value.forEach(schedule => {
    if (schedule.isCheck) {
      checkCount++;
    }
  });
  if (checkCount === 0) {
    swal.alert('선택된 내역이 없습니다.');
    return false;
  }
  const dataIds = [];
  scheduleList.value.forEach(schedule => {
    if (schedule.isCheck) {
      dataIds.push(schedule.partners_data_id);
    }
  });
  const response = await apiService.delete('/v2/booking/provision', {
    fishing_date: date,
    partners_data_ids: dataIds,
  });
  getSchedule();
};
const showMemo = (dataId: string, text: string) => {
  selectedPartnersId.value = dataId;
  memo.value = text;
  isShowMemo.value = true;
};
const closeMemo = () => {
  isShowMemo.value = false;
};
const saveMemo = async () => {
  closeMemo();
  const response = await apiService.patch('/v2/booking/provision/memo', {
    fishing_date: date,
    partners_data_id: selectedPartnersId.value,
    memo: memo.value,
  });
  memo.value = '';
  getSchedule();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _createVNode("div", _hoisted_4, [
          _createVNode("h3", null, _toDisplayString(_unref(date)) + "출조", 1),
          _createVNode("div", null, [
            _createTextVNode(" 매출: " + _toDisplayString(_unref(commerceUtil).getCurrency(summaryData.value?.sales_price)) + "원 - 정산: " + _toDisplayString(_unref(commerceUtil).getCurrency(summaryData.value?.provision_price)) + "원 - 정산완료: " + _toDisplayString(_unref(commerceUtil).getCurrency(summaryData.value?.provisioned_price)) + "원 ", 1),
            _createVNode("div", _hoisted_5, [
              _createVNode(_unref(XlsxWorkbook), null, {
                default: _withId(() => [
                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(sheets.value, (sheet) => {
                    return (_openBlock(), _createBlock(_unref(XlsxSheet), {
                      collection: sheet.data,
                      key: sheet.name,
                      "sheet-name": sheet.name
                    }, null, 8, ["collection", "sheet-name"]))
                  }), 128)),
                  _createVNode("button", {
                    class: "btn btn-primary",
                    onClick: download
                  }, " 정산 xlsx 다운로드 "),
                  _createVNode(_unref(XlsxDownload), { filename: sheetName.value }, {
                    default: _withId(() => [
                      _createVNode("button", {
                        ref: downloadBtn,
                        class: "btn btn-primary",
                        style: {"display":"none"}
                      }, " 발주서 다운로드 ", 512)
                    ]),
                    _: 1
                  }, 8, ["filename"])
                ]),
                _: 1
              }),
              _createVNode("button", {
                class: "btn btn-primary ml-3",
                onClick: showProvision
              }, " 지급요청 완료처리 "),
              _createVNode("button", {
                class: "btn btn-danger ml-3",
                onClick: cancelProvision
              }, " 지급요청 취소처리 ")
            ])
          ])
        ]),
        _createVNode("div", _hoisted_6, [
          _createVNode("div", _hoisted_7, [
            _createVNode("table", _hoisted_8, [
              _createVNode("thead", null, [
                _createVNode("tr", _hoisted_9, [
                  _hoisted_10,
                  _hoisted_11,
                  _hoisted_12,
                  _hoisted_13,
                  _hoisted_14,
                  _hoisted_15,
                  _hoisted_16,
                  _hoisted_17,
                  _hoisted_18,
                  _hoisted_19,
                  _hoisted_20,
                  _hoisted_21,
                  _createVNode("th", null, [
                    _hoisted_22,
                    _hoisted_23,
                    _withDirectives(_createVNode("input", {
                      type: "checkbox",
                      onInput: checkAll,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (isAllCheck.value = $event))
                    }, null, 544), [
                      [_vModelCheckbox, isAllCheck.value]
                    ])
                  ]),
                  _hoisted_24
                ])
              ]),
              _createVNode("tbody", null, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(scheduleList.value, (schedule) => {
                  return (_openBlock(), _createBlock("tr", {
                    key: schedule.data_id
                  }, [
                    _createVNode("td", {
                      onClick: ($event: any) => (viewDetail(schedule.partners_data_id))
                    }, _toDisplayString(schedule.toss_sub_mall_id), 9, ["onClick"]),
                    _createVNode("td", {
                      onClick: ($event: any) => (viewDetail(schedule.partners_data_id))
                    }, _toDisplayString(schedule.partners_profile_nm), 9, ["onClick"]),
                    _createVNode("td", _hoisted_25, _toDisplayString(_unref(commerceUtil).getCurrency(schedule.payment_price)), 1),
                    _createVNode("td", _hoisted_26, _toDisplayString(_unref(commerceUtil).getCurrency(schedule.refund_price)), 1),
                    _createVNode("td", _hoisted_27, _toDisplayString(_unref(commerceUtil).getCurrency(schedule.reservation_sales_price)), 1),
                    _createVNode("td", _hoisted_28, _toDisplayString(_unref(commerceUtil).getCurrency(schedule.penalty_price)), 1),
                    _createVNode("td", _hoisted_29, _toDisplayString(_unref(commerceUtil).getCurrency(schedule.sales_price)), 1),
                    _createVNode("td", _hoisted_30, _toDisplayString(_unref(commerceUtil).getCurrency(schedule.fee)), 1),
                    _createVNode("td", _hoisted_31, _toDisplayString(_unref(commerceUtil).getCurrency(schedule.provision_price)), 1),
                    _createVNode("td", null, _toDisplayString(schedule.provision_status_ko), 1),
                    _createVNode("td", null, _toDisplayString(schedule.provision_date), 1),
                    _createVNode("td", null, _toDisplayString(schedule.provision_req_at), 1),
                    _createVNode("td", _hoisted_32, [
                      (schedule.provision_status !== 'NOT_APPLICABLE')
                        ? _withDirectives((_openBlock(), _createBlock("input", {
                            key: 0,
                            type: "checkbox",
                            "onUpdate:modelValue": ($event: any) => (schedule.isCheck = $event),
                            onInput: ($event: any) => (checkSchedule(schedule))
                          }, null, 40, ["onUpdate:modelValue", "onInput"])), [
                            [_vModelCheckbox, schedule.isCheck]
                          ])
                        : _createCommentVNode("", true)
                    ]),
                    (schedule.memo)
                      ? (_openBlock(), _createBlock("td", _hoisted_33, [
                          _createVNode("p", {
                            class: "memo",
                            onClick: ($event: any) => (
                        showMemo(schedule.partners_data_id, schedule.memo)
                      )
                          }, _toDisplayString(schedule.memo), 9, ["onClick"])
                        ]))
                      : (_openBlock(), _createBlock("td", _hoisted_34, [
                          _createVNode("button", {
                            class: "btn btn-primary",
                            onClick: ($event: any) => (
                        showMemo(schedule.partners_data_id, schedule.memo)
                      )
                          }, " 추가 ", 8, ["onClick"])
                        ]))
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ]),
    _createVNode("div", {
      class: ["admin-modal", { 'show-modal': isShowModal.value }]
    }, [
      _createVNode("div", _hoisted_35, [
        _hoisted_36,
        _createVNode("div", _hoisted_37, [
          _withDirectives(_createVNode("input", {
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (provisionDate.value = $event)),
            type: "date",
            class: "mb-3"
          }, null, 512), [
            [_vModelText, provisionDate.value]
          ]),
          _createVNode("div", { class: "btn-box" }, [
            _createVNode("button", {
              class: "btn btn-primary",
              onClick: provision
            }, " 지급요청 완료 "),
            _createVNode("button", {
              class: "btn btn-danger",
              onClick: closeProvision
            }, "닫기")
          ])
        ])
      ])
    ], 2),
    _createVNode("div", {
      class: ["admin-modal", { 'show-modal': isShowMemo.value }]
    }, [
      _createVNode("div", _hoisted_38, [
        _hoisted_39,
        _createVNode("div", _hoisted_40, [
          _withDirectives(_createVNode("textarea", {
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (memo.value = $event)),
            type: "date",
            class: "mb-3"
          }, null, 512), [
            [_vModelText, memo.value]
          ]),
          _createVNode("div", { class: "btn-box" }, [
            _createVNode("button", {
              class: "btn btn-primary",
              onClick: saveMemo
            }, "저장"),
            _createVNode("button", {
              class: "btn btn-danger",
              onClick: closeMemo
            }, "닫기")
          ])
        ])
      ])
    ], 2)
  ]))
}
}

})